export default __webpack_public_path__ + "static/LarryHMiller-efb78ca0c040af9e698c45a496fb19d1.svg";